'use strict';

angular
  .module('ClinicApp')
  .controller(
    'ModalOCProOptInCtrl',
    function($scope, $modalInstance, clinic, reloadIframe, ClinicService) {
      $scope.clinic = clinic;
      $scope.reloadIframe = reloadIframe;
      $scope.optedIn = _.get(clinic, 'metadata.clinicRoiOptInResponse.optedIn');
      $scope.saving = false;
      $scope.isAgreementActive = false;

      $scope.toggleAgreement = function() {
        $scope.isAgreementActive = !$scope.isAgreementActive;
      };

      $scope.activate = function() {
        $scope.optedIn = $scope.saving = true;
        $scope.save();
      };

      $scope.deactivate = function() {
        $scope.optedIn = false;
        $scope.saving = true;
        $scope.save();
      };

      $scope.save = function() {
        ClinicService.updateClinic($scope.clinic, {
          metadata: {
            clinicRoiOptInResponse: {
              optedIn: $scope.optedIn,
              optedAt: new Date(),
            },
            roiDashboardFeature: $scope.optedIn,
            autoReconciliationFeature: $scope.optedIn,
            opencareProBrandingFeature: $scope.optedIn,
          },
        }).then(() => {
          if ($scope.reloadIframe) {
            $scope.reloadIframe();
          }
          $scope.close();
        })
          .finally(() => {
            $scope.saving = false;
          });
      };

      $scope.close = function() {
        $modalInstance.dismiss('cancel');
      };
    },
  );
